
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/subgraph",
      function () {
        return require("private-next-pages/subgraph/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/subgraph"])
      });
    }
  